const types = {
  CLEAR_CURRENT: 'PRODUCT_VARIANTS_CLEAR_CURRENT',
  GET_REQUEST: 'PRODUCT_VARIANTS_GET_REQUEST',
  GET_SUCCESS: 'PRODUCT_VARIANTS_GET_SUCCESS',
  GET_FAILURE: 'PRODUCT_VARIANTS_GET_FAILURE',

  SAVE_REQUEST: 'PRODUCT_VARIANTS_SAVER_REQUEST',
  SAVE_SUCCESS: 'PRODUCT_VARIANTS_SAVE_SUCCESS',
  SAVE_FAILURE: 'PRODUCT_VARIANTS_SAVE_FAILURE',

  GETALL_REQUEST: 'PRODUCT_VARIANTS_GETALL_REQUEST',
  GETALL_SUCCESS: 'PRODUCT_VARIANTS_GETALL_SUCCESS',
  GETALL_FAILURE: 'PRODUCT_VARIANTS_GETALL_FAILURE',

  DELETE_REQUEST: 'PRODUCT_VARIANTS_DELETE_REQUEST',
  DELETE_SUCCESS: 'PRODUCT_VARIANTS_DELETE_SUCCESS',
  DELETE_FAILURE: 'PRODUCT_VARIANTS_DELETE_FAILURE',    

  UPDATE_REQUEST: 'PRODUCT_VARIANTS_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'PRODUCT_VARIANTS_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'PRODUCT_VARIANTS_UPDATE_FAILURE'    

};

export default types;